import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import ViewPdfModalFromComponent from '../../components/PdfViewer/ViewPdfModalFromComponent';
import { getUserName } from '../../utils/localStoarege';
import { getHfts } from '../../services/clinic/developer_view';
import { formatDateTime } from '../../utils/FormatDateTime';

function DeveloperViewMain() {
    const [cardData, setCardData] = useState([]);

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "S. No.", key: "id" },
        { label: "Machine", key: "machine" },
        { label: "Location", key: "city" },
        { label: "API", key: "api" },
        { label: "Status", key: "status" },
        { label: "Power", key: "power" },
        { label: "Type", key: "type" },
        { label: "Last Used", key: "updated_at" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});


    const pageSize = 10;

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getHfts();
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch invoices");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Invoices:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData(getUserName());
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openPdfModal = (values) => {
        setPdfToDisplay(values);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };
    // Function to copy text to clipboard
    const handleCopy = (id) => {
        const copyText = `http://app.mvrc.co.in/lock_devices/hftsystems/${id}`;
        navigator.clipboard.writeText(copyText)
            .then(() => {
                alert("Copied to clipboard!"); // Optional: Show feedback
            })
            .catch(() => {
                alert("Failed to copy. Please try again."); // Error handling
            });
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: 'Developer' },
            { name: 'HFT' },
        ]} />
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"HFT"} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                id: <p>{index + 1}</p>,
                                machine: <p>{item.machine}</p>,
                                city: <p>{item.location}</p>,
                                status: <p>{item.is_door}</p>,
                                power: <p>{item.is_power ? <div className='w-4 h-4 rounded-full bg-green-500'></div> : <div className='w-4 h-4 rounded-full bg-red-500'></div>}</p>,
                                type: <p>{item.type}</p>,
                                api: <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => handleCopy(item.id)}
                                        className="cursor-pointer p-1 rounded hover:bg-gray-200"
                                        title="Copy to clipboard"
                                    >
                                        <FaCopy size={18} color="gray" />
                                    </button>
                                </div>,
                                updated_at: <p>{formatDateTime(item.updated_at)}</p>,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <ViewPdfModalFromComponent contentLabel={"PDF"} isOpen={modalIsOpen} onRequestClose={closeModal} values={pdfToDisplay} />
    </>);
}

export default DeveloperViewMain;